
import worker from "./worker.ts";

const RPC_PATH = "/api";
const ENV = {"DELAY_AUTH_MS":80,"DELAY_PROFILE_MS":120,"DELAY_NOTIFS_MS":120,"SIMULATED_RTT_MS":120,"SIMULATED_RTT_JITTER_MS":40};

// Anything the Worker itself fetches still goes to the real network.
const upstream = globalThis.fetch.bind(globalThis);

const ctx = {
  waitUntil(promise) { Promise.resolve(promise).catch(() => {}); },
  passThroughOnException() {},
};

// Installed before the client module runs, so a client that wraps `fetch`
// itself -- as the React example does, to time its own requests -- layers on
// top of this and still measures the real call.
globalThis.fetch = async (input, init) => {
  const request = new Request(input, init);
  if (new URL(request.url).pathname === RPC_PATH) {
    return await worker.fetch(request, ENV, ctx);
  }
  return upstream(input, init);
};
